import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'opbillheaderview',
  templateUrl: './opbillheaderview.component.html',
  styleUrls: ['./opbillheaderview.component.scss']
})

export class  OpbillheaderviewComponent implements OnInit {
  
  @Input() hasimage: number;

  public Date: Date;

 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {
    //alert('hasimage');
    this.Date = new Date();
  }
  

 
 
 


 
}
